module.exports = __webpack_public_path__ + "static/media/Rayquaza_gaussian2.f90dea9f.png";